import React from 'react';
import PropTypes from 'prop-types';
import { RECIPE_CARDS_GRID } from '@johnlewispartnership/wtr-content-component-library/dist/component-library/constants/cmsResourceTypes';
import { MealPlannerGrid } from '../../../components/Recipes/MealPlanner/MealPlannerGrid';
import RecipeCardsGrid from '../../../components/Recipes/Content/RecipeCardsGrid';

const CmsRecipeCardsGrid = ({ gridType = '', gridTitle = '', gridSubtitle = '', ...props }) => {
  const isMealPlanner = gridType === 'meal-plan';

  return isMealPlanner ? (
    <MealPlannerGrid title={gridTitle} subtitle={gridSubtitle} />
  ) : (
    <RecipeCardsGrid
      gridType={gridType}
      gridTitle={gridTitle}
      gridSubtitle={gridSubtitle}
      {...props}
    />
  );
};

CmsRecipeCardsGrid.displayName = RECIPE_CARDS_GRID;

CmsRecipeCardsGrid.propTypes = {
  gridType: PropTypes.string,
  gridTitle: PropTypes.string,
  gridSubtitle: PropTypes.string,
};

export default CmsRecipeCardsGrid;
